module.exports = __webpack_public_path__ + "static/img/meeting-banner.7257bf32.png";